import virtual from "@pdfking/workflow/vue/3/virtual"
import object_map from "rfuncs/functions/object_map"

import new_file_from_virtualfile from "../make/new_file_from_virtualfile"

export default (store, { methods, computed, data }) => {
  return virtual({
    data: () => ({
      files: {},
      ...data,
    }),
    mounted() {
      this.populate()
    },
    computed,
    methods: {
      populate() {
        return store.startswith().then(
          files =>
            (this.files = object_map(
              (file, path) => path,
              (file, path) => new_file_from_virtualfile({ path, file }),
              files
            ))
        )
      },
      add_files(files) {
        return Promise.all(
          files.map(async file => {
            await store.set(file.path, await file.get_file())
            this.files[file.path] = file
          })
        )
      },
      remove_files(file_ids) {
        return Promise.all(
          file_ids.map(async id => {
            await store.delete(id)
            delete this.files[id]
          })
        )
      },
      ...methods,
    },
  })
}
